export type MfaObjType = string[];

export enum OrganizationSelectorTabs {
  NOTIFICATIONS = 'notifications',
  ORGANIZATIONS = 'organizations',
}
